export function extractCommaSeparatedValues(csv: string): Array<string> {
  return csv
    .trim()
    .split(",")
    .map((e: string) => e.trim());
}

export const genericStringSplitter = (str = "") =>
  str.split(/(?:,|\s|\n|\t)+/g).filter((token) => token !== "");

// Leading/trailing non-alphanumerics, e.g. the quotes, brackets or
// semicolons that come along when ASINs are pasted from a spreadsheet,
// JSON array or ticket. Interior characters are left alone.
const ASIN_EDGE_NOISE = /^[^A-Za-z0-9]+|[^A-Za-z0-9]+$/g;

/**
 * Normalize one pasted ASIN: strip surrounding punctuation and
 * uppercase it (ASINs are always uppercase alphanumerics), so
 * `"b0hdr3txdw",` becomes `B0HDR3TXDW`. Returns "" when nothing
 * alphanumeric is left.
 */
export const normalizeAsin = (asin = "") =>
  asin.replace(ASIN_EDGE_NOISE, "").toUpperCase();

/**
 * Split a loosely formatted ASIN list (see `genericStringSplitter`)
 * and normalize each entry, dropping entries that end up empty.
 */
export const splitAsins = (str = "") =>
  genericStringSplitter(str)
    .map(normalizeAsin)
    .filter((asin) => asin !== "");

/** Exactly 10 uppercase alphanumerics, same as the backend's ASIN_REGEX. */
export const ASIN_REGEX = /^[A-Z0-9]{10}$/;

/** True when `asin` is a well-formed ASIN (normalize it first). */
export const isValidAsin = (asin: string) => ASIN_REGEX.test(asin);

export const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1, str.length);

export const snakeToCapitalCase = (str: string) =>
  str
    .split("_")
    .map((v) => capitalize(v))
    .join(" ");
